import { ChevronLeft, ChevronRight, FileSpreadsheet, FileText } from "lucide-react";
import { MONTHS } from "@/lib/api";
import { isoWeeks } from "@/lib/weeks";

const sel = "h-11 rounded-lg border border-gray-200 bg-white px-3 text-sm focus:ring-2 focus:ring-emerald-500 focus:outline-none";

export const TimesheetFilters = ({ f, set, operators, canExport, onExport }) => {
  const weeks = isoWeeks(f.year);
  const years = [f.year - 2, f.year - 1, f.year, f.year + 1];

  const step = (dir) => {
    if (f.view === "week") {
      const n = f.week + dir;
      if (n < 1) set({ year: f.year - 1, week: isoWeeks(f.year - 1).length });
      else if (n > weeks.length) set({ year: f.year + 1, week: 1 });
      else set({ week: n });
    } else {
      const n = f.month + dir;
      if (n < 1) set({ year: f.year - 1, month: 12 });
      else if (n > 12) set({ year: f.year + 1, month: 1 });
      else set({ month: n });
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-4 flex flex-wrap items-center gap-3" data-testid="timesheet-filters">
      <div className="inline-flex rounded-lg border border-gray-200 overflow-hidden" role="group" aria-label="Vista">
        {[["week", "Settimana"], ["month", "Mese"]].map(([v, l]) => (
          <button key={v} type="button" data-testid={`ts-view-${v}`} onClick={() => set({ view: v })}
            className={`h-11 px-4 text-sm font-semibold transition-colors ${f.view === v ? "bg-emerald-600 text-white" : "bg-white text-gray-700 hover:bg-gray-50"}`}>
            {l}
          </button>
        ))}
      </div>
      <select data-testid="ts-year" value={f.year} onChange={(e) => set({ year: Number(e.target.value), week: Math.min(f.week, isoWeeks(Number(e.target.value)).length) })} className={sel}>
        {years.map((y) => <option key={y} value={y}>{y}</option>)}
      </select>
      <div className="flex items-center gap-1">
        <button type="button" data-testid="ts-prev" aria-label="Periodo precedente" onClick={() => step(-1)} className="h-11 w-11 rounded-lg border border-gray-200 bg-white flex items-center justify-center hover:bg-gray-50"><ChevronLeft className="h-4 w-4" /></button>
        {f.view === "week" ? (
          <select data-testid="ts-week" value={f.week} onChange={(e) => set({ week: Number(e.target.value) })} className={`${sel} min-w-[260px]`}>
            {weeks.map((w) => <option key={w.week} value={w.week}>{w.label}</option>)}
          </select>
        ) : (
          <select data-testid="ts-month" value={f.month} onChange={(e) => set({ month: Number(e.target.value) })} className={`${sel} min-w-[180px]`}>
            {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m} {f.year}</option>)}
          </select>
        )}
        <button type="button" data-testid="ts-next" aria-label="Periodo successivo" onClick={() => step(1)} className="h-11 w-11 rounded-lg border border-gray-200 bg-white flex items-center justify-center hover:bg-gray-50"><ChevronRight className="h-4 w-4" /></button>
      </div>
      {operators && (
        <select data-testid="ts-operator" value={f.operatorId} onChange={(e) => set({ operatorId: e.target.value })} className={sel}>
          <option value="">Tutti gli operatori</option>
          {operators.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
        </select>
      )}
      {canExport && (
        <div className="flex gap-2 ml-auto">
          <button type="button" data-testid="ts-export-xlsx" onClick={() => onExport("xlsx")} className="h-11 px-4 rounded-lg bg-emerald-600 text-white text-sm font-semibold flex items-center gap-2 hover:bg-emerald-700"><FileSpreadsheet className="h-4 w-4" /> Excel</button>
          <button type="button" data-testid="ts-export-pdf" onClick={() => onExport("pdf")} className="h-11 px-4 rounded-lg bg-emerald-700 text-white text-sm font-semibold flex items-center gap-2 hover:bg-emerald-800"><FileText className="h-4 w-4" /> PDF</button>
        </div>
      )}
    </div>
  );
};
